import {
  Button,
  FormControl,
  FormControlLabel,
  InputAdornment,
  Popover,
  Radio,
  RadioGroup,
} from "@mui/material";
import { useEffect, useState } from "react";
import BottomButton from "../components/BottomButton";
import { useStyles } from "../styles/useStyles";

import { Autocomplete, IconButton, MenuItem } from "@mui/material";
import CloudUploadIcon from "@mui/icons-material/CloudUpload";
import CircularProgress from "@mui/material/CircularProgress";

import TextField from "../overightMui/TextField";

import AddIcon from "@mui/icons-material/Add";
import HorizontalRuleIcon from "@mui/icons-material/HorizontalRule";

import icon_edit from "../../assets/icon_edit.svg";
import Icon_userTF from "../../assets/Icon_userTF.svg";
import icon_mobileTF from "../../assets/icon_mobileTF.svg";
import icon_smsTF from "../../assets/icon_smsTF.svg";
import icon_locationTF from "../../assets/icon_locationTF.svg";
import icon_bsxTF from "../../assets/icon_bsxTF.svg";
import icon_cccdTF from "../../assets/icon_cccdTF.svg";
import icon_vehicle from "../../assets/vehicle-icon.svg";
import icon_upload_img from "../../assets/upload-img-icon.png";
import icon_gender from "../../assets/gender_icon.svg";
import icon_expand_more from "../../assets/icon_expand_more.svg";

export default function Step_2({ state, dispatch, isApp }) {
  const { loadingPrice, vehicleInfo, insuranceInfo, haveLicense, errors, fessTotal } =
    state;
  const classes = useStyles();
  const [uploading, setUploading] = useState(false);

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  const uploadCavet = (file) => {
    if (file) {
      setUploading(true);
      dispatch({
        type: "scanImageV2",
        value: { 
          file,
          productCode: "zuttoride"
        },
        callback: () => setUploading(false),
      });
    }
  }

  const infor_user = [
    {
      name: "buyerName",
      label: "Họ và tên chủ xe",
      value: insuranceInfo?.buyerName || "",
      placeholder: "Nhập họ và tên",
      icon: Icon_userTF,
      helperText: "Ít nhất phải 5 ký tự",
    },
    {
      name: "buyerGender",
      label: "Giới tính",
      value: insuranceInfo?.buyerGender || "",
      placeholder: "Chọn giới tính",
      icon: icon_gender
    },
    {
      name: "buyerPhone",
      label: "Điện thoại",
      value: insuranceInfo?.buyerPhone || "",
      placeholder: "Nhập số điện thoại",
      icon: icon_mobileTF,
      isNumber: true,
      helperText: "SĐT không hợp lệ",
    },
    {
      name: "buyerEmail",
      label: "Email",
      value: insuranceInfo?.buyerEmail || "",
      placeholder: "Nhập email",
      icon: icon_smsTF,
      helperText: "Email không hợp lệ",
    },
    {
      name: "buyerAddress",
      label: "Địa chỉ liên lạc",
      value: insuranceInfo?.buyerAddress || "",
      placeholder: "Nhập địa chỉ",
      icon: icon_locationTF,
      helperText: "Ít nhất phải 10 ký tự",
    },
  ];

  const infor_moto = [
    {
      name: "license",
      label: "Biển số xe",
      value: vehicleInfo?.license || "",
      placeholder: "Nhập biển số xe",
      icon: icon_bsxTF,
      // dontShow: haveLicense === "unLicense",
      helperText: "Ít nhất phải 5 ký tự",
    },
    {
      name: "chassis",
      label: "Số khung xe",
      value: vehicleInfo?.chassis || "",
      placeholder: "Nhập số khung xe",
      icon: icon_bsxTF,
      helperText: "Nhập ít nhất 6 ký tự cuối cùng",
    },
    {
      name: "engine",
      label: "Số máy xe",
      value: vehicleInfo?.engine || "",
      placeholder: "Nhập số máy xe",
      icon: icon_bsxTF,
      helperText: "Nhập ít nhất 6 ký tự cuối cùng",
    },
  ];

  return (
    <>
      <div className={classes.wrapper}>
        <div
          style={{
            fontSize: "15px",
            fontWeight: "600",
            margin: "12px 0",
            lineHeight: "21px",
          }}
        >
          NHẬP THÔNG TIN ĐĂNG KÝ
        </div>
        <div className={classes.note}>
          Thông tin khách hàng cung cấp bên dưới sẽ được lưu trữ trên hệ thống
          của Global Care và đối tác dịch vụ tương ứng nhằm kích hoạt quyền lợi
          và là cơ sở để đảm bảo quyền lợi của khách hàng.
        </div>
        <div style={{
          display: "flex",
          flexDirection: "row",
          gap: "10px",
          marginTop: 16
        }}>
          <div
            style={{
              borderRadius: 8,
              padding: 5,
              backgroundColor: "#FFFFFF",
              border: "0.5px solid #D2D2D2",
              flex: 1
            }}>
            <div
              style={{
                borderRadius: 10,
                padding: 5,
                backgroundColor: "#F3F3F3",
              }}>
              <div style={{
                display: "flex",
                flexDirection: "column",
                gap: "5px",
              }}>
                <img src={vehicleInfo?.scanedCard ?? icon_vehicle} style={{ width: "100%" }} />
                <Button
                  component="label"
                  variant="outlined"
                  disabled={uploading}
                  startIcon={
                    uploading ? (
                      <CircularProgress size={20} sx={{ color: "black" }} />
                    ) : (
                      <img src={icon_upload_img} alt="upload" />
                    )
                  }
                  sx={{
                    borderColor: "#D2D2D2 !important",
                    borderWidth: "0.5px !important",
                    borderRadius: "6px !important",
                    backgroundColor: "white",
                    fontWeight: 500,
                    cursor: "pointer",
                    padding: "8px 12px",
                    textTransform: "none",
                    color: "black",
                    height: 30,
                    "&:hover": {
                      backgroundColor: "#f5f5f5",
                      borderColor: "#bdbdbd",
                    },
                  }}
                >
                  {uploading ? "Đang xử lý..." : "Tải ảnh lên"}
                  <input
                    hidden
                    accept="image/*"
                    type="file"
                    onChange={(e) => {
                      const file = e.target.files?.[0];
                      uploadCavet(file)
                    }}
                  />
                </Button>
              </div>
            </div>
          </div>
          <div style={{ flex: 1 }}>
            <span style={{ color: "#F37021", fontStyle: "italic", fontSize: 13 }}>
              Chụp thông tin giấy đăng ký xe (Cà vẹt xe) để nhập nhanh thông tin
            </span>{" "}
            <span style={{ color: "#9E9E9E", fontStyle: "italic", fontSize: 13 }}>
              (không bắt buộc)
            </span>
          </div>

        </div>
        <div className={classes.box_infor_user}>
          {infor_user.map((item, index) => (
            <div style={{ margin: "12px 0" }} key={`infor_user_${index}`}>
              <div style={{ marginBottom: "6px" }}>
                {item.label} <span style={{ color: "red" }}> * </span>
              </div>

              {item.name === "buyerGender" ? (
                <TextField
                  select
                  fullWidth
                  value={insuranceInfo?.buyerGender ?? ""}
                  SelectProps={{
                    displayEmpty: true,
                    IconComponent: () => null,
                  }}
                  error={
                    errors?.step2?.includes(item.name)
                  }
                  helperText={
                    errors?.step2?.includes(item.name)
                      ? "Vui lòng nhập thông tin!"
                      : false
                  }
                  InputProps={{
                    startAdornment: (
                      <InputAdornment position="start">
                        <img src={item.icon} width={18} />
                      </InputAdornment>
                    ),
                    endAdornment: (
                      <InputAdornment position="end">
                        <img src={icon_expand_more} />
                      </InputAdornment>
                    )
                  }}
                  sx={{
                    "& .MuiInputBase-root": {
                      background: "white",
                      borderRadius: "8px",
                      paddingLeft: "10px",
                      "& input": { paddingLeft: "0px" },
                    },
                    "& .MuiSelect-select": {
                      paddingLeft: "0px",
                    },
                    // "& .MuiSvgIcon-root": {
                    //   display: "none",
                    // },
                    borderRadius: "8px",
                  }}
                  onChange={(e) => {
                    dispatch({
                      type: "onChangeInsuranceInfo",
                      name: "buyerGender",
                      value: e.target.value,
                    });
                  }}
                >
                  <MenuItem value="" style={{ display: "none" }}>
                    <span style={{ color: "rgb(162 162 162)" }}>
                      {item.placeholder}
                    </span>
                  </MenuItem>
                  <MenuItem value={1}>Nam</MenuItem>
                  <MenuItem value={2}>Nữ</MenuItem>
                </TextField>
              ) : (
                <TextField
                  key={item.name}
                  type={item.name === "buyerPhone" ? "tel" : "text"}
                  fullWidth
                  value={item.value}
                  error={
                    errors?.step2?.includes(item.name) ||
                    errors?.step2?.includes(`${item.name}_length`)
                  }
                  helperText={
                    errors?.step2?.includes(item.name)
                      ? "Vui lòng nhập thông tin!"
                      : errors?.step2?.includes(`${item.name}_length`)
                        ? item.helperText
                        : false
                  }
                  placeholder={item.placeholder}
                  onChange={(e) => {
                    if (item.isNumber) {
                      if (/^\d*$/.test(e.target.value)) {
                        dispatch({
                          type: "onChangeInsuranceInfo",
                          name: item.name,
                          value: e.target.value,
                        });
                      }
                    } else {
                      dispatch({
                        type: "onChangeInsuranceInfo",
                        name: item.name,
                        value: e.target.value,
                      });
                    }
                  }}
                  InputProps={{
                    startAdornment: (
                      <InputAdornment position="start">
                        <img src={item.icon} />
                      </InputAdornment>
                    ),
                  }}
                  sx={{
                    "& .MuiInputBase-root": {
                      background: "white",
                      borderRadius: "8px",
                      paddingLeft: "10px",
                      "& input": { paddingLeft: "0px" },
                    },
                    borderRadius: "8px",
                  }}
                />
              )}
            </div>
          ))}
          {infor_moto.map((item, index) =>
            item.dontShow ? null : (
              <div style={{ margin: "12px 0" }} key={`infor_moto_${index}`}>
                <div style={{ marginBottom: "6px" }}>
                  {item.label} <span style={{ color: "red" }}>*</span>
                </div>
                <TextField
                  error={
                    errors?.step2?.includes(item.name) ||
                    errors?.step2?.includes(`${item.name}_length`)
                  }
                  helperText={
                    errors?.step2?.includes(item.name)
                      ? "Vui lòng nhập thông tin!"
                      : errors?.step2?.includes(`${item.name}_length`)
                        ? item.helperText
                        : false
                  }
                  value={item.value}
                  onChange={(e) =>
                    dispatch({
                      type: "onChangeVelhicleInfor",
                      name: item.name,
                      value: e.target.value,
                    })
                  }
                  fullWidth
                  placeholder={item.placeholder}
                  sx={{
                    "& .MuiInputBase-root": {
                      background: "white",
                      borderRadius: "8px",
                      paddingLeft: "10px",

                      "& .MuiInputBase-input": {
                        textTransform:
                          item.name === "license" ? "uppercase" : "",
                        paddingLeft: "0px",
                      },

                      "& .MuiInputBase-input::placeholder": {
                        textTransform: "none",
                      },
                    },
                    borderRadius: "8px",
                  }}
                  InputProps={{
                    startAdornment: (
                      <InputAdornment position="start">
                        <img src={item.icon} />
                      </InputAdornment>
                    ),
                  }}


                />
              </div>
            )
          )}
        </div>
      </div>
      <BottomButton
        disabled={loadingPrice}
        onBack={() => dispatch("comeBackPage")}
        fessTotal={fessTotal}
        onClick={
          () => {
            dispatch("validatePage");
            dispatch("nextPage")
          }
        }
        title="Tiếp tục"
      />
    </>
  );
}
